export default __webpack_public_path__ + "static/media/logo.201f1aa3.svg";